import { Achievement } from "../backend/Achievement";

export const ACHIEVEMENTS_SUPPORTED = false;

export function unlockAchievement(achievementName: Achievement): void {
  // Do nothing, by default unlocking achievements is a no-op
  console.log("unlocking " + achievementName);
  return;
}
